// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"VideoModal_modalContainer__1L8Pm","modal":"VideoModal_modal__22tJI","closeButton":"VideoModal_closeButton__1rzAK"};